(ns pfo.admin.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [reagent.core :as reagent :refer [atom]]
            [pfo.auth.model :as auth-model :refer [is-user-license-admin]]
            [pfo.admin.model :as model]
            [pfo.admin.component :as component]
            [pfo.collection.model :as collection-model]
            [pfo.api :refer [process-error]]
            [pfo.common.component :refer [empty-page]]
            [pfo.flash :refer [set-flash]]
            [pfo.util :as util]
            [pfo.scope.scope :as scope]
            [keechma.next.core :as keechma]
            [pfo.controller :as controller]
            [pfo.staticparam :as staticparam]))

(defn user-edit [{:keys [id query-params]}]
  (let [model-func (if (is-user-license-admin)
                     model/license-admin-user-details
                     model/group-admin-user-details)]
    (->> (model-func id)
         (p/map (fn [response]
                  (util/set-page (#'component/user-edit response))))
         (process-error)))
  (util/set-initial-page empty-page))

(defn user-add [{:keys [query-params]}]
  (util/set-page #'component/user-add))

(defroute "/admin/collection/edit/:id/" [id query-params]
  (->> (p/all [(collection-model/collection-full-details id)
               (collection-model/permitted-groups id)
               (collection-model/collection-ancestors id)])
       (p/map (fn [[collection permitted-groups ancestor-list]]
                (util/set-page (#'component/collection-edit {:permitted-groups permitted-groups
                                                             :tab (when (= "permissions" (:tab query-params)) (keyword (:tab query-params)))}
                                                            collection nil ancestor-list))))

       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/collection/details/edit/:id/" [id]
  (->> (collection-model/collection-full-details id)
       (p/map (fn [response] (util/set-page (#'component/collection-family-details-edit {} response))))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/collection/add/" [query-params]
  (util/set-page (#'component/collection-edit {} nil (:parent_id query-params))))

(defn user-list [{:keys [query-params]}]
  (let [model-func (if (is-user-license-admin)
                     (fn [_ active order page-number] (model/license-admin-user-list active order page-number nil))
                     (fn [_ active order page-number] (model/group-admin-user-list active order page-number)))]
    (->> (model-func nil "active" "name")
         (p/map (fn [response]
                  (util/set-page (#'component/admin-tabs nil (partial component/user-list response nil model-func) :users))))
         (process-error))
    (util/set-initial-page empty-page)))

(defroute "/admin/contact/list" [query-params]
  (let [options {:selected-group-atom (atom nil)}]
    (util/set-page (#'component/admin-tabs options (partial component/contact-list options (:group_id query-params)) :contacts))))

(defroute "/admin/contact/add" [query-params]
  (util/set-page (#'component/admin-tabs nil (partial component/contact-edit nil nil (:group_id query-params)) :contacts)))

(defroute "/admin/contact/import" [query-params]
  (util/set-page (#'component/admin-tabs nil (partial component/contacts-import nil nil (:group_id query-params)) :contacts)))

(defn contact-edit [query-params]
  (->> (model/group-admin-contact-user-details (:id query-params))
       (p/map #(util/set-page (#'component/admin-tabs nil (partial component/contact-edit nil % (:family_id %)) :contacts)))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/group/list" []
  (->> (model/license-admin-groups)
       (p/map (fn [response]
                (util/set-page (#'component/admin-tabs nil (partial component/group-list response) :groups))))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/group/:id/edit" [id]
  (->> (p/all [(model/license-admin-group-details id)
               (model/license-admin-user-list "active" nil nil id)])
       (p/map (fn [[family-details-response user-list-response]]
                (util/set-page (#'component/admin-tabs {:hide-controls true} (partial component/family-details family-details-response user-list-response) :groups))))
       (process-error))
  (util/set-initial-page empty-page))

(defn family-edit [{:keys [id]}]
  (->> (p/all [(model/license-admin-group-details id)
               (model/license-admin-user-list "active" nil nil id)])
       (p/map (fn [[family-details-response user-list-response]]
                (util/set-page (#'component/admin-tabs {:hide-controls true} (partial component/family-details family-details-response user-list-response) :groups))))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/group/add" []
  (util/set-page (#'component/admin-tabs {:hide-controls true} (partial component/group-edit nil) :groups)))

(defroute "/admin/invitation/list" []
  (util/set-page (#'component/admin-tabs nil (partial component/user-invitation-list nil) :invitations)))

(defroute "/profile" []
  (util/set-page (#'component/admin-tabs nil component/user-profile-edit :profile)))

(defroute "/invitations/:uid/" [uid]
  (->> (auth-model/invitation-details uid)
       (p/map (fn [response]
                (util/set-page (#'component/admin-tabs nil (partial component/user-invitation response) :profile))))
       (p/error (fn [{status :status :as err}]
                  (if (= 404 status)
                    (set-flash :error "Invitation is invalid")
                    (throw err))))
       (process-error))
  (util/set-initial-page empty-page))

(defn templategroup-list [{:keys [query-params]}]
  (let [options {:selected-group-atom (atom (some-> (:group_id query-params) not-empty util/str->int))
                 :selected-subscriber-atom (atom (some-> (:subscriber_id query-params) not-empty util/str->int))
                 :compliance-atom (atom (if-let [atype (:type query-params)] (= atype "compliance") (model/can-view-template-list true)))
                 :show-hidden (atom (if-let [show-hidden (:show_hidden query-params)] (= show-hidden "yes") false))
                 :filter-active (atom (or (:filter_active query-params) "active"))
                 :order (atom (or (:order query-params) "name"))}]
    (util/set-page
     ((if (auth-model/is-user-any-family-admin)
        #'component/template-tabs
        #'component/admin-tabs) options (partial component/templategroup-list options) :compliance-templates))))

(defn templategroup-add [{:keys [query-params]}]
  (util/set-page (#'component/templategroup-add
                  (util/apply-waypoint-params
                   {:compliance (= "compliance" (:type query-params))}
                   query-params [:group_id :subscriber_id :type :show_hidden :filter_active :order])
                  (:group_id query-params) (:subscriber_id query-params))))

(defn templategroup-edit [{:keys [id query-params]}]
  (let [group-id (not-empty (:group_id query-params))
        subscriber-id (not-empty (:subscriber_id query-params))]
    (->> (p/all [(if (is-user-license-admin)
                   (model/license-admin-templategroup id)
                   (model/templategroup-get id))
                 (if  group-id (collection-model/collection-details group-id) (p/promise nil))
                 (if subscriber-id (model/subscriber subscriber-id))])
         (p/map (fn [[template-group group subscriber]]
                  (util/set-page
                   (#'component/templategroup-details
                    (util/apply-waypoint-params
                     {:group      group
                      :subscriber subscriber}
                     query-params [:group_id :subscriber_id :type :show_hidden :filter_active :order])
                    group-id subscriber-id template-group))))
         (process-error)))
  (util/set-initial-page empty-page))

(defn templategroup-preview [{:keys [id query-params]}]
  (let [group-id (not-empty (:group_id query-params))
        subscriber-id (not-empty (:subscriber_id query-params))]
    (->> (p/all [(if (is-user-license-admin)
                   (model/license-admin-templategroup id)
                   (model/templategroup-get id))
                 (if  group-id (collection-model/collection-details group-id) (p/promise nil))
                 (if subscriber-id (model/subscriber subscriber-id))])
         (p/map (fn [[template-group group subscriber]]
                  (util/set-page
                   (#'component/templategroup-details
                    (util/apply-waypoint-params
                     {:group      group
                      :subscriber subscriber
                      :preview    true}
                     query-params [:group_id :subscriber_id :type :show_hidden :filter_active :order])
                    group-id subscriber-id template-group))))
         (process-error)))
  (util/set-initial-page empty-page))


(defn demo-list []
  (util/set-page (#'component/admin-tabs (atom nil) #(component/demo-list) :demo)))

(defn category-list [{{:keys [group_id active]} :query-params :as params}]
  (let [query-params (:query-params params)
        selected-group-atom (atom (some-> (:group query-params) not-empty util/str->int))
        selected-subscriber-atom (atom (some-> (:subscriber query-params) not-empty util/str->int))]
    (util/set-page
     (#'component/admin-tabs {:selected-group-atom selected-group-atom
                              :selected-subscriber-atom selected-subscriber-atom}
                             (partial component/category-list selected-subscriber-atom selected-group-atom (not-empty active))
                             :categories))))

(defn subscribers-list [params]
  (util/set-page (#'component/admin-tabs (atom nil) #(component/subscribers-list) :subscribers-list)))

(defn subscriber-edit [params]
  (->> (model/license-admin-subscriber-details (:id params))
       (p/map #(util/set-page (#'component/admin-tabs (atom nil) (partial component/subscriber-edit %) :subscribers-list)))
       (process-error))
  (util/set-initial-page empty-page))

(defn subscriber-add [params]
  (util/set-page (#'component/admin-tabs (atom nil) #(component/subscriber-edit nil) :subscribers-list)))

(defn bulk-edit-list [{:keys [query-params]}]
  (let [selected-group-atom (atom nil)]
    (util/set-page (#'component/admin-tabs {:selected-group-atom selected-group-atom} (partial component/bulk-edit-list selected-group-atom (:group_id query-params)) :bulk-edits))))

(defroute "/admin/bulkedit/:id/item/list" [id query-params]
  (let [selected-group-atom (atom nil)]
    (util/set-page (#'component/admin-tabs {:selected-group-atom selected-group-atom} (partial component/bulk-edit-item-list selected-group-atom (:group_id query-params) id) :bulk-edits))))

(defn bulk-apply-details [{:keys [operation-id query-params]}]
  (let [selected-group-atom (atom nil)]
    (controller/dispatch :bulk-apply-items :load {:group-id (:group_id query-params)
                                                  :operation-id operation-id
                                                  :page 1})
    (util/set-page (#'component/admin-tabs {} (partial component/bulk-apply-details nil (:group_id query-params) operation-id) :bulk-edits)))
  (util/set-initial-page empty-page))

(defroute "/admin/category/:id/edit" [id query-params]
  (let [scope (scope/from-str (:operation_scope query-params))]
    (->> ((condp = (:level scope)
            scope/level-family model/group-admin-category-details
            scope/level-subscriber model/group-admin-category-details
            scope/level-global model/license-admin-category-details)
          id)
         (p/map #(util/set-page (#'component/category-edit scope % (:active query-params))))
         (process-error)))
  (util/set-initial-page empty-page))

(defroute "/admin/category/add" [query-params]
  (let [scope (scope/from-str (:operation_scope query-params))]
    (util/set-page (#'component/category-edit scope nil (:active query-params)))))

(defroute "/admin/assettype/list" [query-params]
  (let [options {:selected-group-atom (atom nil)}]
    (util/set-page (#'component/admin-tabs options (partial component/asset-type-list options (not-empty (:group_id query-params))) :asset-types))))

(defroute "/admin/assettype/:id/edit" [id query-params]
  (->> (model/group-admin-category-details id)
       (p/map #(util/set-page (#'component/category-edit (:group_id query-params) %)))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/collectiontype/list" [query-params]
  (let [selected-group-atom (atom nil)]
    (util/set-page (#'component/admin-tabs {:selected-group-atom selected-group-atom} (partial component/category-list selected-group-atom (:group_id query-params)) :collection-types))))

(defroute "/admin/collectiontype/:id/edit" [id query-params]
  (->> (model/group-admin-category-details id)
       (p/map #(util/set-page (#'component/category-edit (:group_id query-params) %)))
       (process-error))
  (util/set-initial-page empty-page))

(defroute "/admin/collectiontype/add" [query-params]
  (util/set-page (#'component/category-edit (:group_id query-params) nil)))

(defn application-licenses [{{:keys [task_type]} :query-params :as params}]
  (when staticparam/license-management-enabled
    (util/set-page (#'component/admin-tabs nil (partial component/application-licenses) :applicenses))))

(defn nomination-list [{:keys [query-params]}]
  (let [options {}]
    (util/set-page (#'component/admin-tabs options component/nominations :nominations))))

(defn disposition-list [{:keys [query-params query-param-vectors]}]
  (let [selected-family-atom (atom (:family_id query-params))
        options {:selected-family-atom selected-family-atom
                 :order (atom (:order query-params))
                 :uid (atom (:uid query-params))
                 :collection_name (atom (:collection_name query-params))
                 :label_ids (atom (mapv util/str->int (:label_id query-param-vectors)))}]
    (util/set-page
     (#'component/automation-tabs options (partial component/disposition-list options) :disposition-list))))

(defn ai [{:keys [query-params query-param-vectors]}]
  (util/set-page
   (#'component/ai-tabs nil #'component/ai-settings :settings-ai)))

(defn ai-lmp [{:keys [query-params query-param-vectors]}]
  (util/set-page
   (#'component/ai-tabs nil #'component/ai-lmp :settings-ai-lmp)))

(defn ai-usage [{:keys [query-params]}]
  (let [options {:subscriber-id (not-empty (:subscriber_id query-params))
                 :family-id (not-empty (:family_id query-params))
                 :year (not-empty (:year query-params))
                 :month (not-empty (:month query-params))
                 :non-zero (not= "false" (:non_zero query-params))
                 :family-breakdown (= "true" (:family_breakdown query-params))
                 :order (or (not-empty (:order query-params)) "subscriber_name")
                 :page (or (some-> (:page query-params) not-empty util/str->int) 1)}]
    (util/set-page
     (#'component/report-tabs options (partial #'component/ai-usage options) :settings-ai-usage))))

(defn ai-skill [{:keys [query-params query-param-vectors]}]
  (util/set-page
   (#'component/ai-tabs nil #'component/ai-skill :settings-ai-skill)))

(defn ai-debug [{:keys [query-params query-param-vectors]}]
  (util/set-page
   (#'component/ai-tabs nil #'component/ai-debug :settings-ai-debug)))

(defn ai-feedback [{:keys [query-params]}]
  (let [options {:subscriber-id (not-empty (:subscriber_id query-params))
                 :family-id (not-empty (:family_id query-params))
                 :time-range (not-empty (:time_range query-params))
                 :order (or (not-empty (:order query-params)) component/feedback-default-order)
                 :page (or (some-> (:page query-params) not-empty util/str->int) 1)}]
    (util/set-page
     (#'component/ai-tabs options (partial #'component/ai-feedback options) :settings-ai-feedback))))

(defn ai-billing [{:keys [query-params query-param-vectors]}]
  (util/set-page
   (#'component/ai-tabs nil #'component/ai-billing :settings-ai-billing)))

(defn dropbox-sign-report [{:keys [query-params query-param-vectors]}]
  (let [selected-family-atom (atom (:family_id query-params))
        options {:selected-family-atom selected-family-atom
                 :order (atom (:order query-params))
                 :uid (atom (:uid query-params))
                 :collection_name (atom (:collection_name query-params))
                 :label_ids (atom (mapv util/str->int (:label_id query-param-vectors)))}]
    (util/set-page
     (#'component/report-tabs options component/dropbox-sign-report :dropbox-sign-report))))

(defn transaction-list [{:keys [query-params]}]
  (let [selected-family-atom (atom (:family_id query-params))
        controls (atom nil)
        options {:controls-atom controls
                 :refresh-atom (atom false)}]
    (util/set-page (#'component/automation-tabs options (partial component/transaction-list options selected-family-atom) :transaction-list))))

(defn transaction-document-list [{:keys [id query-params]}]
  (let [controls (atom nil)]
    (util/set-page (#'component/automation-tabs {:show-back-button true
                                                 :controls-atom controls} (partial component/transaction-document-list nil id) :transaction-list))))

(defroute "/disposition/add" [query-params]
  (util/set-page (#'component/disposition-edit (:family_id query-params) nil)))

(defroute "/disposition/:id/edit/" [id query-params]
  (->> (model/disposition id)
       (p/map #(util/set-page (#'component/disposition-edit (:family_id query-params) %)))
       (process-error))
  (util/set-initial-page empty-page))

(defn automation-collection-list [{:keys [query-params query-param-vectors]}]
  (let [selected-family-atom (atom (:family_id query-params))
        controls (atom nil)
        options (merge
                 {:controls-atom controls
                  :refresh-atom (atom false)
                  :selected-family-atom selected-family-atom
                  :order (atom (:order query-params))
                  :uid (atom (:uid query-params))
                  :collection_name (atom (:collection_name query-params))
                  :label_ids (atom (mapv util/str->int (:label_id query-param-vectors)))})]
    (util/set-page (#'component/automation-tabs options (partial component/automation-collection-list options selected-family-atom) :automation-collection-list))))

(defn label-list [{:keys [query-params]}]
  (let [selected-family-atom (atom (:family_id query-params))
        controls (atom nil)
        options {:controls-atom controls
                 :refresh-atom (atom false)
                 :selected-family-atom selected-family-atom
                 :object-type model/object-type-disposition}]
    (util/set-page (#'component/automation-tabs options (partial component/label-list options selected-family-atom) :label-list))))

(defn disposition-import [{:keys [id]}]
  (let [options {:family-id id}]
    (util/set-page (#'component/automation-tabs options (partial component/disposition-import options) :disposition-list))))

(defn template-label-list [{:keys [query-params]}]
  (let [selected-family-atom (atom (:family_id query-params))
        controls (atom nil)
        options {:controls-atom controls
                 :refresh-atom (atom false)
                 :selected-family-atom selected-family-atom
                 :object-type model/object-type-task-template-group}]
    (util/set-page (#'component/template-tabs options (partial component/template-label-list options selected-family-atom) :template-label-list))))

(defn metrics  [{:keys [query-params]}]
  (let [selected-group-atom (atom (some-> (:group query-params) not-empty util/str->int))
        selected-subscriber-atom (atom (some-> (:subscriber query-params) not-empty util/str->int))]
    (util/set-page      
     (#'component/admin-tabs {:selected-group-atom selected-group-atom
                              :selected-subscriber-atom selected-subscriber-atom}
                             (partial component/metrics selected-subscriber-atom selected-group-atom)
                             :metrics))))
